import UserProfileNetworkingBlock from './UserProfileNetworkingBlock';

export default UserProfileNetworkingBlock;
